import ReportsInformeClubView from './views/ReportsInformeClubView.vue'

export default [
  {
    path: '/reportes-informes-club',
    name: 'reportes-info-club',
    component: ReportsInformeClubView
  }
]
